module.exports = __webpack_public_path__ + "files/94d6e653c6599c3f2489adb0de301f19.png";